<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-12">
            <yt-input
            [Type]="'text'"
            name="txtNaziv"
            formControlName="Naziv"
            #focusElement
            [MaxLength]="100"
            [ngClass]="{'is-invalid' : submitted && fc.Naziv.invalid}"
            [Label]="'TIPRADNEOPREME.NAZIV.SINGULAR'">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-12">
            <yt-dropdown-picklist
                [ModelName]="'velicinaset'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="VelicinaSetID"
                [Label]="'TIPRADNEOPREME.VELICINASET.SINGULAR'"
            >
            </yt-dropdown-picklist>
        </div>
    </div>      
  </form>